// TODO: add all here

// NOTE: when ALL logos are added here, size is standardized, and adequately useable,
// we should move management of these logos to Sanity... the only issue with that
// is that we won't be to use the logos as inline SVGs, which is a nice feature.
// maybe there is a way to do both?

// NOTE: keep these alphabetical
export { default as agentSync } from './agentSync'
export { default as americanBanker } from './americanBanker'
export { default as ascend } from './ascend'
export { default as axios } from './axios'
export { default as capsule } from './capsule'
export { default as carta } from './carta'
export { default as compound } from './compound'
export { default as coverGenius } from './coverGenius'
export { default as careSend } from './careSend'
export { default as clarityClinic } from './clarityClinic'
export { default as dollarFor } from './dollarFor'
export { default as divvy } from './divvy'
export { default as firstAmerican } from './firstAmerican'
export { default as firstAscent } from './firstAscent'
export { default as flyhomes } from './flyhomes'
export { default as geoWealth } from './geoWealth'
export { default as ganaz } from './ganaz'
export { default as gridline } from './gridline'
export { default as healthMe } from './healthMe'
export { default as hiive } from './hiive'
export { default as jobAndTalent } from './jobAndTalent'
export { default as layr } from './layr'
export { default as mainStreet } from './mainStreet'
export { default as nestegg } from './nestegg'
export { default as opto } from './opto'
export { default as optionsAI } from './optionsAI'
export { default as pathpoint } from './pathpoint'
export { default as pacificWorkplaces } from './pacificWorkplaces'
export { default as seso } from './seso'
export { default as sunrise } from './sunrise'
export { default as spruceHealth } from './spruceHealth'
export { default as vave } from './vave'
export { default as vero } from './vero'
export { default as vouch } from './vouch'
